import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { GuardService } from './services/guard/guard.service';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadChildren: () => import('./pages/auth/login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'reset-pwd',
        loadChildren: () => import('./pages/auth/reset-pwd/reset-pwd.module').then(m => m.ResetPwdPageModule)
    },
    {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
        canActivate: [GuardService]
    },
    {
        path: 'profile',
        loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
        canActivate: [GuardService]
    },
    {
        path: 'activation-list',
        loadChildren: () => import('./pages/activation/activation-list/activation-list.module').then(m => m.ActivationListPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'activation-pre',
        loadChildren: () => import('./pages/activation/activation-pre/activation-pre.module').then(m => m.ActivationPrePageModule),
        canActivate: [GuardService]
    },
    {
        path: 'quality',
        loadChildren: () => import('./pages/quality/quality.module').then(m => m.QualityPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'extract',
        loadChildren: () => import('./pages/extract/extract.module').then(m => m.ExtractPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'my-rescue',
        loadChildren: () => import('./pages/my-rescue/my-rescue.module').then(m => m.MyRescuePageModule),
        canActivate: [GuardService]
    },
    {
        path: 'privacy-policy',
        loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule)
    },
    {
        path: 'benefits',
        loadChildren: () => import('./pages/benefits/benefits.module').then(m => m.BenefitsPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'regulation',
        loadChildren: () => import('./pages/regulation/regulation.module').then(m => m.RegulationPageModule)
    },
    {
        path: 'multi-awards',
        loadChildren: () => import('./pages/multi-awards/multi-awards.module').then(m => m.MultiAwardsPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'help',
        loadChildren: () => import('./pages/help/help.module').then(m => m.HelpPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'information',
        loadChildren: () => import('./pages/information/information.module').then(m => m.InformationPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'plans',
        loadChildren: () => import('./pages/plans/plans.module').then(m => m.PlansPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'area-logada/loja/vale-combustivel/0',
        redirectTo: 'store/store-fuel'
    },
    {
        path: 'area-logada/loja/combustivel/0',
        redirectTo: 'store/store-fuel'
    },
    {
        path: 'area-logada/loja/shell-box/0',
        redirectTo: 'store/store-fuel'
    },
    {
        path: 'area-logada/loja/:subcategory/:subcategory',
        redirectTo: 'store/store-list-product/:subcategory/:subcategory'
    },
    {
        path: 'store/store-list-product/pagamento-de-contas/0',
        redirectTo: 'store/store-pay-the-bills'
    },
    {
        path: 'store/store-list-product/recarga-de-celular/0',
        redirectTo: 'store/store-phone-recharge'
    },
    {
        path: 'store/store-list-product/shell-box/0',
        redirectTo: 'store/store-fuel'
    },
    {
        path: 'store',
        loadChildren: () => import('./pages/store/store.module').then(m => m.StorePageModule),
        canActivate: [GuardService]
    },
    {
        path: 'sign-up',
        loadChildren: () => import('./pages/sign-up/sign-up.module').then(m => m.SignUpPageModule)
    },
    {
        path: 'quiz/:id',
        loadChildren: () => import('./pages/quiz/quiz.module').then(m => m.QuizPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'face-register',
        loadChildren: () => import('./pages/auth/face-register/face-register.module').then(m => m.FaceRegisterPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'wallet',
        loadChildren: () => import('./pages/wallet/wallet.module').then(m => m.WalletPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'multiluck',
        loadChildren: () => import('./pages/multiluck/multiluck.module').then(m => m.MultiluckPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'challenges',
        loadChildren: () => import('./pages/challenges/challenges.module').then(m => m.ChallengesPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'faq',
        loadChildren: () => import('./pages/faq/faq.module').then(m => m.FacPageModule),
        canActivate: [GuardService]
    },
    {
        path: 'team',
        loadChildren: () => import('./pages/team/team.module').then( m => m.TeamPageModule),
        canActivate: [GuardService]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
